import Select from "react-select";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import PageHeader from "./../../../components/PageHeader/PageHeader";
import InfoItem from "./../../../helpers/InfoItem/InfoItem";
import HotelStars from "./../../../helpers/HotelStars/HotelStars";
import ErrorMessage from "../../../helpers/ErrorMessage/ErrorMessage";
import EmptyData from "./../../../helpers/EmptyData/EmptyData";
import Button from "./../../../components/Button/Button";
import Icon from "../../../components/Icon/Icon";
import Currency, {
  ConvertCurrency,
} from "./../../../helpers/Currency/Currency";
import { hotelUserContext } from "../../../context/UserContext/HotelUserContext/HotelUserContext";
import { convertDate, convertRoleToPath, sumWallets } from "../../../utils";
import { createBooksValidation } from "../../../utils/validation/validation";
import {
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "./../../../components/DataTable/DataTable";
import {
  convertGenderTypeToText,
  convertHotelServiceToText,
  servicesItems,
} from "../../../utils/enum";

const ReserveHotelUser = () => {
  const auth = useSelector((state) => state.auth);
  const loader = useSelector((state) => state.loader);

  const [, setRefresh] = useState(null);

  const { handleCreateBook, handleGetPassengers } =
    useContext(hotelUserContext);

  const navigate = useNavigate();

  const { state: room } = useLocation();
  const hotel = room?.hotel;

  // Validation
  const {
    control,
    register,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(createBooksValidation),
  });
  useEffect(() => {
    if (isEmpty(room)) {
      navigate("/");
    } else if (!!setValue) {
      const initialGuest = {
        first_name: "",
        foreigner: false,
        last_name: "",
      };
      const initialRoom = {
        extra_beds: 0,
        guests: [...Array(room?.adults)]?.map((_) => initialGuest),
        id: room?.id,
      };
      const rooms = [...Array(room?.count)]?.map((_) => initialRoom);

      setValue("rooms", rooms);
    }
  }, [setValue]);

  useEffect(() => {
    handleGetPassengers();
  }, []);

  // reserve steps
  const [step, setStep] = useState("1");
  const [payModal, setPayModal] = useState(false);
  const [addServicesModal, setAddServicesModal] = useState(false);

  // Wallet
  const wallet = useSelector((state) => state.user.wallet);
  const walletSum = sumWallets(wallet) || 0;
  const walletButtons = [
    { key: "all", text: "همه موجودی", value: walletSum },
    { key: "1mill", text: "1 میلیون", value: 1000000 },
    { key: "3mill", text: "3 میلیون", value: 3000000 },
    { key: "5mill", text: "5 میلیون", value: 5000000 },
  ];
  const [walletUse, setWalletUse] = useState(walletButtons[0]);
  const changeActiveBtn = (item) => {
    setWalletUse(item);
    if (walletSum < item.value)
      setTimeout(() => {
        setWalletUse(walletButtons[0]);
      }, 1000);
  };

  const title = `${room?.hotel?.accommodation_type ?? ""} ${room?.hotel?.title ?? ""
    }`;
  const extraBedPrice = watch("rooms")?.reduce(
    (prev, current) =>
      (prev += current.extra_beds * room?.pricing?.extra_bed_price),
    0
  );
  const totalAmount =
    room?.pricing?.local_price_off * room?.count + extraBedPrice;

  if (step == "1")
    return (
      <>
        <SiteTitle title={`رزرو ${title}`} />

        {/* -- ---- -- ---- >> Header << ---- -- ---- -- */}

        <div
          style={{
            width: "103.86%",
            marginRight: "-2%",
            height: "20vh",
            overflow: "hidden",
            background: "#321349",
            boxShadow: "0 0 0 15px #321349",
          }}
          className="mt-n4"
        >
          <nav
            className="nav mt-4 mt-xxl-5 mb-4"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <div className="d-flex flex-column align-items-center">
              <div
                className="rounded-circle d-flex justify-content-center align-items-center bg-orange"
                style={{ width: "40px", height: "40px" }}
              >
                <span
                  className="text-center rounded-circle bg-white text-orange cursor-default"
                  aria-disabled="true"
                  href="#"
                  style={{ width: "20px", height: "20px" }}
                >
                  ✔
                </span>
              </div>
            </div>
            <div className="border-top" style={{ width: "15%" }}></div>
            <div className="d-flex flex-column align-items-center">
              <div
                className="rounded-circle d-flex justify-content-center align-items-center"
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#fee0d2",
                }}
              >
                <span
                  className="text-center rounded-circle text-orange cursor-default"
                  href="#"
                  style={{ width: "20px", height: "20px" }}
                >
                  2
                </span>
              </div>
            </div>

            <div className="border-top" style={{ width: "15%" }}></div>
            <div className="d-flex flex-column align-items-center">
              <div
                className="border rounded-circle d-flex justify-content-center align-items-center"
                style={{ width: "40px", height: "40px" }}
              >
                <span
                  className="text-center text-white cursor-default"
                  href="#"
                  style={{ width: "20px", height: "20px" }}
                >
                  3
                </span>
              </div>
            </div>
          </nav>
          <div className="d-flex align-items-center justify-content-center gap-2 mt-3 mt-lg-2">
            <div style={{ width: "40px", textWrap: "nowrap" }}>
              <p
                className="text-white position-relative"
                style={{ right: "-40%" }}
              >
                انتخاب هتل
              </p>
            </div>
            <div style={{ width: "15%" }}></div>
            <div style={{ width: "40px", textWrap: "nowrap" }}>
              <p
                className="text-white position-relative"
                style={{ right: "-60%" }}
              >
                اطلاعات مسافران
              </p>
            </div>
            <div style={{ width: "15%" }}></div>
            <div style={{ width: "40px", textWrap: "nowrap" }}>
              <p
                className="text-white position-relative"
                style={{ right: "-40%" }}
              >
                جزئیات پرداخت
              </p>
            </div>
          </div>
        </div>

        {/* -- ---- -- ---- >> Passengers Form << ---- -- ---- -- */}
        <Card
          style={{ borderRadius: "25px" }}
          className="ml-xxl-5 mt-lg-n4 mt-xxl-n5 mt-n4"
        >
          <CardBody>
            <Form
              action="#"
              className="is-alter"
              onSubmit={handleSubmit(() => {
                setStep(2);
              })}
            >
              {isEmpty(watch("rooms")) ? (
                <EmptyData title="اتاقی برای نمایش یافت نشد" />
              ) : (
                <>
                  {watch("rooms")?.map((item, index) => (
                    <Card key={index} className="mb-3 no-bdr">
                      <CardHeader className="h5 bg-white">
                        اتاق {room?.title}
                      </CardHeader>
                      <CardBody>
                        <Row className="gy-4">
                          {item?.guests?.map((_item, _index) => (
                            <Col lg="6" key={_index} className="mb-3">
                              <p className="d-flex justify-content-between align-items-end">
                                <span className="h6 pb-1">
                                  <Icon
                                    name="user"
                                    className="mr-1 text-orange"
                                  />
                                  مهمان شماره {_index + 1}
                                </span>
                                <Passengers
                                  onChange={(item) => {
                                    setValue(
                                      `rooms[${index}].guests[${_index}].first_name`,
                                      item.firstName
                                    );
                                    setValue(
                                      `rooms[${index}].guests[${_index}].last_name`,
                                      item.lastName
                                    );
                                  }}
                                />
                              </p>

                              <Row className="gy-4">
                                <Col sm="6">
                                  <FormGroup>
                                    <div className="form-label-group">
                                      <label
                                        className="form-label"
                                        htmlFor={`rooms[${index}].guests[${_index}].first_name`}
                                      >
                                        نام
                                      </label>
                                    </div>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        placeholder="نام مهمان خود را وارد نمایید"
                                        className="form-control-lg form-control"
                                        {...register(
                                          `rooms[${index}].guests[${_index}].first_name`
                                        )}
                                      />

                                      {errors.rooms && (
                                        <ErrorMessage
                                          message={
                                            errors.rooms[index]?.guests[_index]
                                              ?.first_name?.message
                                          }
                                        />
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col sm="6">
                                  <FormGroup>
                                    <div className="form-label-group">
                                      <label
                                        className="form-label"
                                        htmlFor={`rooms[${index}].guests[${_index}].last_name`}
                                      >
                                        نام‌خانوادگی
                                      </label>
                                    </div>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        placeholder="نام‌خانوادگی مهمان خود را وارد نمایید"
                                        className="form-control-lg form-control"
                                        {...register(
                                          `rooms[${index}].guests[${_index}].last_name`
                                        )}
                                      />

                                      {errors.rooms && (
                                        <ErrorMessage
                                          message={
                                            errors.rooms[index]?.guests[_index]
                                              ?.last_name?.message
                                          }
                                        />
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <div className="form-control-wrap mt-3">
                                <Controller
                                  control={control}
                                  render={({
                                    field: { onChange, value, onBlur },
                                  }) => (
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input form-control"
                                        checked={value}
                                        onChange={(e) =>
                                          onChange(e.target.checked)
                                        }
                                        onBlur={onBlur}
                                        id={`rooms[${index}].guests[${_index}].foreigner`}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor={`rooms[${index}].guests[${_index}].foreigner`}
                                      >
                                        این اتاق میزبان مسافر خارجی است.
                                      </label>
                                    </div>
                                  )}
                                  name={`rooms[${index}].guests[${_index}].foreigner`}
                                />
                                {errors?.rooms && (
                                  <ErrorMessage
                                    message={
                                      errors?.rooms[index]?.guests[_index]
                                        ?.foreigner?.message
                                    }
                                  />
                                )}

                                <div className="border-top mt-5" />
                              </div>
                            </Col>
                          ))}
                        </Row>

                        {room?.extra_bed > 0 && (
                          <FormGroup>
                            <div className="form-label-group">
                              <label
                                className="form-label"
                                htmlFor={`rooms[${index}].extra_beds`}
                              >
                                تخت اضافه
                              </label>
                            </div>
                            <div className="form-control-wrap mb-3">
                              <Controller
                                control={control}
                                render={({
                                  field: { onChange, value, onBlur },
                                }) => (
                                  <div
                                    className="form-control-wrap number-spinner-wrap"
                                    dir="ltr"
                                  >
                                    <Button
                                      type="button"
                                      color="light"
                                      outline
                                      disabled={value >= room?.extra_bed}
                                      className="btn-icon number-spinner-btn number-minus"
                                      onClick={() => {
                                        setRefresh(Math.random());
                                        onChange(value + 1);
                                      }}
                                    >
                                      <Icon name="plus" />
                                    </Button>
                                    <input
                                      type="number"
                                      className="form-control number-spinner bg-white"
                                      value={value}
                                      readOnly
                                      disabled
                                      onBlur={onBlur}
                                    />
                                    <Button
                                      type="button"
                                      color="light"
                                      outline
                                      disabled={value <= 0}
                                      className="btn-icon number-spinner-btn number-plus"
                                      onClick={() => {
                                        setRefresh(Math.random());
                                        onChange(value - 1);
                                      }}
                                    >
                                      <Icon name="minus" />
                                    </Button>
                                  </div>
                                )}
                                name={`rooms[${index}].extra_beds`}
                              />
                              {errors?.rooms && (
                                <ErrorMessage
                                  message={
                                    errors?.rooms[index]?.extra_beds?.message
                                  }
                                />
                              )}
                            </div>
                          </FormGroup>
                        )}
                      </CardBody>
                    </Card>
                  ))}
                </>
              )}
              <Row className="gy-4 align-items-end">
                <Col lg="4">
                  <FormGroup>
                    <div className="form-label-group">
                      <label className="form-label" htmlFor="special_requests">
                        در صورتی که درخواست ویژه ای از هتل دارید اینجا وارید
                        کنید
                      </label>
                    </div>
                    <div className="form-control-wrap">
                      <textarea
                        type="text"
                        style={{ height: 200, maxHeight: 200, minHeight: 200 }}
                        className="form-control-lg form-control"
                        {...register("special_requests")}
                      />

                      <ErrorMessage
                        message={errors.special_requests?.message}
                      />
                    </div>
                  </FormGroup>
                  {/* <FormGroup>
              <div className="form-label-group">
                <label className="form-label" htmlFor="discount_code">
                  کد تخفیف
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="text"
                  placeholder="کد تخفیف خود را وارد نمایید"
                  className="form-control-lg form-control"
                  {...register("discount_code")}
                />

                <ErrorMessage message={errors.discount_code?.message} />
              </div>
            </FormGroup> */}
                </Col>
                <Col lg="4">
                  <p className="font-weight-bold mb-0">توجه داشته باشید</p>
                  <p className="text-justify">
                    در صورت انتخاب خدمات اضافه، بعد از تایید توسط پشتیبان‌های ما
                    و تایید نهایی توسط شما هزینه به سفارش اضافه میگردد.
                  </p>
                  <FormGroup>
                    <div className="form-label-group">
                      <label className="form-label" htmlFor="special_requests">
                        <p className="fw-bold">
                          خدمات اضافه{" "}
                          <span className="text-muted">(اختیاری)</span>
                        </p>
                      </label>
                    </div>
                    <div className="form-control-wrap">
                      <Controller
                        control={control}
                        render={({ field: { onChange, value, onBlur } }) => (
                          <>
                            <Select
                              isMulti
                              onMenuOpen={() => setAddServicesModal(true)}
                              onBlur={onBlur}
                              noOptionsMessage={() => (
                                <span>خدماتی برای نمایش یافت نشد</span>
                              )}
                              placeholder=""
                              value={value}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              options={servicesItems.map((item) => ({
                                value: item,
                                label: convertHotelServiceToText(item),
                              }))}
                              onChange={onChange}
                            />

                            <Modal
                              isOpen={addServicesModal}
                              className="modal-dialog-centered"
                              size="md"
                              toggle={() => setAddServicesModal(false)}
                            >
                              <ModalBody>
                                <div className="d-flex flex-column">
                                  <div className="d-flex flex-column align-start">
                                    <p className="text-soft">خدمات اضافه</p>
                                    <h5>برای انتخاب هر یک کلیک کنید</h5>
                                    <p className="text-dark">توجه: انتخاب هر یک از خدمات اضافه بر هزینه سفر تاثیرگذار خواهد بود.</p>

                                  </div>
                                  <div className="d-flex flex-column mt-3">
                                    {servicesItems.map((item, index) => {
                                      const isChecked = value?.find((selectedItem) => selectedItem.value === item) !== undefined
                                      return (
                                        <div className="custom-control custom-checkbox d-flex my-2 justify-between align-center text-dark cursor-pointer"
                                          onClick={(e) => {
                                            const selectedValues = value || [];
                                            if (isChecked) {
                                              // If already checked, uncheck it
                                              onChange(selectedValues.filter((val) => val.value !== item));
                                            } else {
                                              // If unchecked, check it
                                              onChange([...selectedValues, { value: item, label: convertHotelServiceToText(item) }]);
                                            }
                                          }}
                                        >
                                          <p className="m-0">{convertHotelServiceToText(item)}</p>
                                          <input
                                            type="checkbox"
                                            className="custom-control-input form-control"
                                            id={`services[${index}]`}
                                            checked={isChecked}
                                            onChange={(e) => {
                                              const selectedValues = value || [];
                                              if (e.target.checked) {
                                                // Add item to the array if checked
                                                onChange([...selectedValues, { value: item, label: convertHotelServiceToText(item) }]);
                                              } else {
                                                // Remove item from the array if unchecked
                                                onChange(selectedValues.filter((val) => val.value !== item));
                                              }
                                            }}
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor={`services[${index}]`}
                                          >{' '}</label>
                                        </div>
                                      )
                                    }
                                    )}
                                  </div>
                                </div>
                              </ModalBody>
                            </Modal>

                          </>
                        )}
                        name="services"
                      />

                      <ErrorMessage message={errors.services?.message} />
                    </div>
                  </FormGroup>
                </Col>
                <Col lg="4">
                  <table className="table table-striped">
                    <tfoot>
                      <tr>
                        <td></td>
                        <td>مجموع قیمت</td>
                        <td>
                          <ConvertCurrency
                            price={room?.pricing?.local_price * room?.count}
                          />{" "}
                          <Currency />
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>مجموع تخفیف</td>
                        <td>
                          <ConvertCurrency
                            price={
                              (room?.pricing?.local_price -
                                room?.pricing?.local_price_off) *
                              room?.count
                            }
                          />{" "}
                          <Currency />
                        </td>
                      </tr>
                      {!!extraBedPrice && (
                        <tr>
                          <td></td>
                          <td>قیمت تخت اضافه</td>
                          <td>
                            <ConvertCurrency price={extraBedPrice} />{" "}
                            <Currency />
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td></td>
                        <td>مبلغ قابل پرداخت</td>
                        <td>
                          <ConvertCurrency price={totalAmount} /> <Currency />
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                  <br />

                  <div className="d-flex flex-column justify-content-center w-100">
                    <Button
                      className="w-100 justify-center"
                      loading={loader}
                      type="submit"
                      color="primary"
                      size="lg"
                    >
                      تایید
                    </Button>
                    <Link
                      className="link link-light d-flex justify-content-center mb-3 mt-4"
                      type="button"
                      to={`/${convertRoleToPath(auth.role)}/hotels`}
                      replace
                    >
                      انصراف
                    </Link>
                  </div>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </>
    );

  // -------- ------ >> Step 2
  return (
    <>
      <SiteTitle title={`رزرو ${title}`} />
      {/* -- ---- -- ---- >> Header << ---- -- ---- -- */}

      <div
        style={{
          width: "103.86%",
          marginRight: "-2%",
          height: "20vh",
          overflow: "hidden",
          background: "#321349",
          boxShadow: "0 0 0 15px #321349",
        }}
        className="mt-n4"
      >
        <nav className="nav mt-4 mt-xxl-5 mb-4 d-flex align-items-center justify-content-center gap-2">
          <div className="d-flex flex-column align-items-center">
            <div
              className="rounded-circle d-flex justify-content-center align-items-center bg-orange"
              style={{ width: "40px", height: "40px" }}
            >
              <a
                className="text-center rounded-circle bg-white text-orange"
                href="#"
                style={{ width: "20px", height: "20px" }}
              >
                ✔
              </a>
            </div>
          </div>
          <div className="border-top" style={{ width: "15%" }}></div>
          <div className="d-flex flex-column align-items-center">
            <div
              className="rounded-circle d-flex justify-content-center align-items-center bg-orange"
              style={{ width: "40px", height: "40px" }}
            >
              <a
                className="text-center rounded-circle bg-white text-orange"
                href="#"
                style={{ width: "20px", height: "20px" }}
              >
                ✔
              </a>
            </div>
          </div>

          <div className="border-top" style={{ width: "15%" }}></div>
          <div className="d-flex flex-column align-items-center">
            <div
              className="rounded-circle d-flex justify-content-center align-items-center"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#fee0d2",
              }}
            >
              <a
                className="text-center rounded-circle text-orange"
                href="#"
                style={{ width: "20px", height: "20px" }}
              >
                3
              </a>
            </div>
          </div>
        </nav>
        <div className="d-flex align-items-center justify-content-center gap-2 mt-5">
          <div style={{ width: "40px", textWrap: "nowrap" }}>
            <p
              className="text-white position-relative"
              style={{ right: "-40%" }}
            >
              انتخاب هتل
            </p>
          </div>
          <div style={{ width: "15%" }}></div>
          <div style={{ width: "40px", textWrap: "nowrap" }}>
            <p
              className="text-white position-relative"
              style={{ right: "-60%" }}
            >
              اطلاعات مسافران
            </p>
          </div>
          <div style={{ width: "15%" }}></div>
          <div style={{ width: "40px", textWrap: "nowrap" }}>
            <p
              className="text-white position-relative"
              style={{ right: "-40%" }}
            >
              جزئیات پرداخت
            </p>
          </div>
        </div>
      </div>

      {/* -- ---- -- ---- >> Wallet << ---- -- ---- -- */}
      <div className="wide-md container-fluid p-0">
        <Card
          style={{ borderRadius: "25px" }}
          className="bg-primary align-self-center shadow w-xl-75 ml-xxl-5 mt-lg-n4 mt-xxl-n5 mt-n4 no-bdr px-2 px-lg-4"
        >
          <CardBody>
            <Col className="text-center mt-4">
              <p className="text-white-50" style={{ fontSize: "16px" }}>
                کیف پول الکترونیکی
              </p>
              <Row className="justify-center">
                <div className="h2 text-light mt-n1">
                  <ConvertCurrency price={walletSum} />{" "}
                  <small className="text-white-50" style={{ fontSize: "16px" }}>
                    تومان
                  </small>
                </div>
              </Row>
            </Col>

            <p className="text-white-50 pb-3 pt-4 center">
              مبلغ تخفیف را انتخاب کنید
            </p>

            <Row className="justify-between mt-3 text-light">
              <p>مبلغ استفاده از کیف پول</p>
              <div>
                <ConvertCurrency price={walletUse.value} /> <small>تومان</small>
              </div>
            </Row>

            <div className="center mb-4 container-fluid">
              <div className="center w-100">
                <input
                  type="range"
                  class="form-range w-100"
                  min="0"
                  max={walletSum}
                  step={Math.floor(walletSum / 50)} // change if needed
                  onMouseUp={(e) =>
                    setWalletUse({ key: "", text: "", value: e.target.value })
                  }
                  onTouchEndCapture={(e) =>
                    setWalletUse({ key: "", text: "", value: e.target.value })
                  }
                ></input>
              </div>
            </div>

            <Row className="justify-between justify-content-md-center">
              {walletButtons.map((item) => (
                <WalletBtn
                  item={item}
                  onClick={changeActiveBtn}
                  active={walletUse}
                />
              ))}
            </Row>

            <Row className="text-light mt-4 mb-n3 justify-between">
              <p>مانده کیف پول پس از تراکنش</p>
              <div className={walletSum - walletUse.value < 0 && "text-danger"}>
                <ConvertCurrency price={walletSum - walletUse.value} />{" "}
                <small>تومان</small>
              </div>
            </Row>
          </CardBody>
        </Card>

        <div className="mt-4">
          <div className="border-top mt-xxl-5 mb-xxl-3" />

          <Row className="justify-content-between pt-2 px-2 px-lg-4">
            <p className="text-dark">مبلغ کل خدمات</p>
            <div className="h6">
              <ConvertCurrency
                price={room?.pricing?.local_price_off * room?.count}
              />{" "}
              <small className="text-black-50">تومان</small>
            </div>
          </Row>
          <Row className="justify-content-between pt-2 px-2 px-lg-4">
            <p className="text-dark">ارزش افزوده</p>
            <div className="h6">
              <ConvertCurrency
                price={room?.pricing?.local_price_off * room?.count}
              />{" "}
              <small className="text-black-50">تومان</small>
            </div>
          </Row>
          <Row className="justify-content-between pt-2 px-2 px-lg-4">
            <p className="text-dark">مبلغ استفاده از کیف پول</p>
            <div className="h6">
              <ConvertCurrency price={walletUse.value} />{" "}
              <small className="text-black-50">تومان</small>
            </div>
          </Row>

          <div className="border-top my-xxl-3" />

          <Row className="justify-content-between rounded p-2 px-lg-4">
            <p className="text-dark m-0">مبلغ قابل پرداخت</p>
            <div className="h6">
              <ConvertCurrency
                price={room?.pricing?.local_price_off * room?.count} // ---- --- Fix with correct values
              />{" "}
              <small className="text-black-50">تومان</small>
            </div>
          </Row>
          <Button
            color="primary"
            size="lg"
            className="w-100"
            onClick={() => setPayModal(true)}
          >
            <p className="text-center w-100">پرداخت</p>
          </Button>
          <Row className="pt-3 pb-1 align-center justify-center">
            <button
              type="button"
              onClick={() => setStep(1)}
              className="link link-light"
            >
              انصراف
            </button>
          </Row>
        </div>
      </div>

      <Modal
        isOpen={payModal}
        className="modal-dialog-centered"
        size="md"
        toggle={() => setPayModal(false)}
      >
        <ModalBody>
          <Col className="px-4">
            <Row className="justify-content-between">
              <Row size={8} className="align-items-center">
                <img
                  src={hotel?.gallery[0].media}
                  alt=""
                  width={70}
                  height={70}
                  className="rounded-lg mr-3"
                />
                <Col>
                  <p className="text-muted">هتل انتخاب شده</p>
                  <h6>{title}</h6>
                </Col>
              </Row>
              <div className="align-self-center">
                <HotelStars stars={hotel.stars} />
              </div>
            </Row>
            <Row className="justify-content-between my-4">
              <div
                className="rounded-lg bg-lighter text-center py-1"
                style={{ width: "47.5%" }}
              >
                <p>تاریخ ورود</p>
                <h6>{convertDate(room.from)}</h6>
              </div>
              <div
                className="rounded-lg bg-lighter text-center py-1"
                style={{ width: "47.5%" }}
              >
                <p>تاریخ خروج</p>
                <h6>{convertDate(room.to)}</h6>
              </div>
            </Row>
            <Row className="bg-lighter rounded-lg p-2 mb-4">
              <div>
                <p className="text-mute">اتاق‌ها</p>
                <h6>اتاق {room.title}</h6>
              </div>
            </Row>
            <Row className="justify-content-between rounded p-2">
              <p className="text-mute m-0">مبلغ کل</p>
              <div>
                <ConvertCurrency
                  price={room?.pricing?.local_price * room.count}
                />{" "}
                <Currency />
              </div>
            </Row>
            <Row className="justify-content-between rounded p-2 mb-3">
              <p className="text-mute m-0">مجموع تخفیف</p>
              <div>
                <ConvertCurrency
                  price={
                    (room?.pricing?.local_price -
                      room?.pricing?.local_price_off) *
                    room?.count
                  }
                />{" "}
                <Currency />
              </div>
            </Row>
            <Row className="justify-content-between rounded p-2 mb-2">
              <p className="text-dark m-0">مبلغ قابل پرداخت</p>
              <div>
                <ConvertCurrency
                  price={room?.pricing?.local_price_off * room?.count}
                />{" "}
                <Currency />
              </div>
            </Row>

            <Row className="w-100 justify-content-center mb-3">
              <Button
                color="primary"
                size="lg"
                className="w-100 justify-content-center"
                onClick={handleSubmit((data) =>
                  handleCreateBook(data, totalAmount)
                )} //// ======================================== >> >> >> Change
              >
                نهایی کردن خرید
              </Button>
            </Row>
            <Row className="w-100 justify-content-center">
              <button
                type="button"
                onClick={() => setPayModal(false)}
                className="link link-light"
              >
                انصراف
              </button>
            </Row>
          </Col>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ReserveHotelUser;

const Passengers = ({ onChange }) => {
  const { passengers, handleGetPassengers } = useContext(hotelUserContext);

  const [isShowModal, setIsShowModal] = useState(false);

  return (
    <>
      <Button
        color="info"
        type="button"
        outline
        onClick={() => setIsShowModal(true)}
      >
        <Icon name="users" className="mr-1" /> انتخاب مسافران سابق
      </Button>

      <Modal
        isOpen={isShowModal}
        toggle={() => setIsShowModal(false)}
        className="modal-dialog-centered"
        size="xl"
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => setIsShowModal(false)}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">مسافران ثبت شده</h5>
            <br />
            <Col md="6">
              <input
                className="form-control"
                placeholder="نام، نام خانوادگی، شماره موبایل، کد ملی و..."
                onChange={(e) => handleGetPassengers(e.target.value)}
              />
            </Col>
            <br />
            <DataTableBody>
              <DataTableHead>
                <DataTableRow>
                  <span className="sub-text">نام و نام خانوادگی</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">جنسیت</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">کد ملی</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">شماره موبایل</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">تاریخ تولد</span>
                </DataTableRow>
                <DataTableRow />
              </DataTableHead>
              {/*Head*/}
              {passengers.length > 0 &&
                passengers.map((item) => {
                  return (
                    <DataTableItem key={item._id}>
                      <DataTableRow>
                        <div className="user-card">
                          <div className="user-avatar">
                            <span>
                              {item.firstName[0]}
                              {item.lastName[0]}
                            </span>
                          </div>
                          <div className="user-info">
                            <span className="tb-lead fw-bold">
                              {item.firstName} {item.lastName}
                            </span>
                            <span>
                              {item.firstNameLatin} {item.lastNameLatin}
                            </span>
                          </div>
                        </div>
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span>{convertGenderTypeToText(item.gender)}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span>{item.nationalNumber}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span>{item.phoneNumber}</span>
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span>{convertDate(item.birthDate)}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <Button
                          color="primary"
                          onClick={() => {
                            onChange(item);
                            setIsShowModal(false);
                          }}
                        >
                          انتخاب
                        </Button>
                      </DataTableRow>
                    </DataTableItem>
                  );
                })}
            </DataTableBody>
            <div className="card-inner">
              {passengers.length <= 0 && (
                <div className="text-center">
                  <span className="text-silent">
                    داده ای برای نمایش یافت نشد
                  </span>
                </div>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

const WalletBtn = ({ item, onClick, active }) => {
  return (
    <Button
      key={item.key}
      className={`py-1 px-1 px-md-2 mx-md-1 ${item.key === active.key ? "bg-white" : "bg-primary-glass"
        }`}
      style={{ borderRadius: "8px" }}
      size="lg"
      onClick={() => onClick(item)}
    >
      <small className={item.key === active.key ? "text-black" : "text-white"}>
        {item.text}
      </small>
    </Button>
  );
};
